// @flow

import React, { Component } from 'react';
import { DebounceInput } from 'react-debounce-input';
import 'client/styles/form.scss';

export type InputProps = {
  className: string,
  debounceDuration: number,
  id: string,
  onBlur: Function,
  onChange: Function,
  onFocus: Function,
  placeholder: string,
  shouldFocus: boolean,
  type: string,
  value: number | string,
};

export const inputDefaultProps = {
  className: '',
  debounceDuration: 0,
  id: '',
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
  placeholder: '',
  shouldFocus: false,
  type: 'text',
  value: '',
};

export default class Input extends Component<InputProps> {
  static defaultProps = inputDefaultProps;

  componentDidUpdate(prevProps: InputProps) {
    if (this.props.shouldFocus && !prevProps.shouldFocus) {
      if (this.element) {
        this.element.focus();
      }
    }
  }

  element: HTMLInputElement | null;

  render() {
    const { shouldFocus, debounceDuration, ...props } = this.props;
    return debounceDuration > 0 ? (
      <DebounceInput
        debounceTimeout={debounceDuration}
        inputRef={(el) => {
          if (el) {
            this.element = el;
          }
        }}
        {...props} />
    ) : (
      <input
        ref={(el) => {
          if (el) {
            this.element = el;
          }
        }}
        {...props} />
    );
  }
}
